<template>
  <div>
    <div class="search d-flex align-items-center">
      <div class="w search-box d-flex align-items-center">
        <div class="logo d-flex align-items-center">
          <router-link to="/" :title="common_info.store.name"
            ><img
              class="img-default search-img"
              :src="common_info.store.logo"
              :alt="common_info.store.name"
          /></router-link>
          <div class="shop" v-if="mch && mch.id">
            <router-link
              :to="{ path: '/shop', query: { mch_id: mch.id } }"
              class="shop-name show-one-lines"
              v-text="mch.name"
            ></router-link>
            <!-- <div class="shop-name show-one-lines" v-text="mch.name"></div> -->
            <div class="d-flex align-items-center">
              <span
                class="show-one-lines"
                v-if="mch.address"
                :title="'地址：' + mch.address"
                >店铺信息</span
              >
              <span
                class="show-one-lines"
                v-text="'评分：' + mch.score"
                v-if="!mch.address && mch.score"
              ></span>
              <div
                class="d-flex align-items-center customer_service"
                @click="webService('mch')"
                v-if="customer_service"
              >
                <img
                  class="img-default shop-img"
                  src="../../assets/images/service.png"
                  alt
                />
                <span>在线客服</span>
              </div>
            </div>
          </div>
          <template v-else>
            <div class="shop">
              <p class="shop-name show-one-lines">平台自营</p>
              <div class="d-flex align-items-center">
                <span
                  class="show-one-lines"
                  v-if="store.contact_tel"
                  :title="'电话：' + store.contact_tel"
                  >店铺信息</span
                >
                <template v-if="store.option">
                  <div
                    class="d-flex align-items-center customer_service"
                    @click="webService()"
                    v-if="
                      store.option &&
                      store.option.web_service_status == 1 &&
                      store.option.web_service_url
                    "
                  >
                    <img
                      class="img-default shop-img"
                      src="../../assets/images/service.png"
                      alt
                    />
                    <span>在线客服</span>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
        <div class="search-c">
          <div class="search-item">
            <div class="box">
              <img
                class="img-default img"
                src="../../assets/images/search.png"
                alt
              />
              <input
                placeholder="搜索商品"
                class="search-input"
                type="text"
                v-model="searchtext"
                ref="searchtext"
              />
            </div>
            <div class="search-btn" @click="searchshop()">搜索</div>
            <div class="search-btn2" v-if="mch && mch.id && false">搜本店</div>
          </div>
        </div>
        <div class="cat" @click="cartgoto()">
          <img class="img-default xia" src="../../assets/images/cat.svg" alt />
          我的购物车
          <span v-text="carnum"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mch: {
      type: Object,
      default() {
        return {};
      },
    },
    customer_service: {
      type: String,
      default() {
        return "";
      },
    },
    store: {
      type: Object,
      default() {
        return {};
      },
    },
    goods: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      login: true,
      // common_info: {
      // 	store: {}
      // },
      searchtext: "", //搜索商品
      carnum: 0, //购物车数量
    };
  },
  computed: {
    common_info() {
      let simulate = {
        store: {},
      };
      let commonData = this.$store.state.common_info || simulate;
      return commonData;
    },
  },
  created() {
    let that = this;
    this.common.loginType(this);
    // this.common.getCommonInfo(this);
    if (!this.login) {
      this.cartnumapi();
    }
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key === 13) {
        if (that.$refs.searchtext.value) {
          that.searchshop();
        }
      }
    };
  },
  methods: {
    // 购物车数量
    cartnumapi() {
      if (this.$store.state.user) {
        if (this.$store.state.user.token != "") {
          this.$api
            .cartnum()
            .then((res) => {
              this.carnum = res.data;
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    cartgoto() {
      this.$router.push("/cat");
    },
    // 搜索商品
    searchshop() {
      let searchname = this.$refs.searchtext.value;
      if (searchname == "") {
        this.$message({
          showClose: true,
          message: "搜索商品不可为空",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
      } else {
        let parms = {
          keyword: searchname,
        };
        if (this.catid) {
          parms.id = this.catid;
        }
        this.$router.push({
          path: "/list",
          query: parms,
        });
      }
    },
    // 客服
    webService(type) {
      let goods = this.goods;
      let store = this.store;
      let customer_service = this.customer_service;
      if (this.$store.state.user) {
        if (this.$store.state.user.token != "") {
          let url_str = this.common.webService(
            this,
            goods,
            store,
            type,
            customer_service
          );
          window.open(url_str);
        } else {
          this.$router.push({
            name: "signin",
            query: {
              redirect: this.$router.currentRoute.fullPath,
            },
          });
        }
      } else {
        this.$router.push({
          name: "signin",
          query: {
            redirect: this.$router.currentRoute.fullPath,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  height: 112px;
  background-color: #fff;
  width: 100%;

  .search-box {
    display: flex;
    height: 112px;
    // padding-top: 32px;
    box-sizing: border-box;

    .logo {
      > a {
        display: block;
        width: 187px;
        height: 55px;
        margin-right: 44px;
      }

      .logo-img {
        width: 187px;
        height: 55px;
        object-fit: contain;
        display: block;
      }

      .search-img {
        width: auto;
        height: auto;
        object-fit: fill;
        display: block;
        margin: 0 auto;
        max-width: 100%;
        max-height: 100%;
      }

      .shop {
        width: 140px;
        position: relative;

        &::after {
          content: "";
          width: 1px;
          height: 55px;
          background: #ebebeb;
          position: absolute;
          top: -5px;
          left: -21px;
        }

        .shop-name {
          font-size: 14px;
          color: #666666;
          margin-bottom: 10px;
          font-weight: 500;
          display: block;
        }

        span {
          color: #999999;
        }

        .shop-img {
          width: 12px;
          height: 12px;
          margin-left: 20px;
          margin-right: 4px;
        }
      }
    }

    .search-c {
      margin-left: auto;

      .search-item {
        display: flex;

        .box {
          width: 310px;
          height: 36px;
          border: 2px solid #ff0008;
          box-sizing: border-box;
          display: flex;
          align-items: center;

          .img {
            height: 10px;
            width: 10px;
            margin-left: 10px;
            margin-right: 4px;
          }

          .search-input {
            width: 100%;
            height: 32px;
            // border: 0 none;
            // box-sizing: border-box;
          }
        }

        .search-btn {
          width: 90px;
          height: 36px;
          background-color: #ff0008;
          color: #fff;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }

        .search-btn2 {
          width: 90px;
          height: 36px;
          background-color: #ff9010;
          color: #fff;
          font-size: 18px;
          margin-left: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      // .search-default {
      //   display: flex;
      //   margin-top: 8px;
      //   color: #b3b3b3;
      //   li {
      //     margin-right: 8px;
      //   }
      // }
    }

    .cat {
      height: 40px;
      width: 120px;
      border: 1px solid #ff0008;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ff0008;
      box-sizing: border-box;
      margin-left: 32px;
      cursor: pointer;
      border-radius: 2px;
      position: relative;

      span {
        position: absolute;
        top: 3px;
        left: 23px;
        right: auto;
        display: inline-block;
        padding: 1px 3px;
        font-size: 12px;
        line-height: 12px;
        color: #fff;
        background-color: #e1251b;
        border-radius: 7px;
        min-width: 12px;
        text-align: center;
      }

      .xia {
        height: 18px;
        width: 18px;
        margin-right: 12px;
      }
    }
  }
}

.customer_service {
  cursor: pointer;
}
</style>
